import { useState } from "react";
import ChatPopup from "./ChatPopup";

export default function ChatIcon({ role }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating Icon */}
      <div
        onClick={() => setOpen(true)}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          background: "#2563eb",
          color: "#fff",
          width: "52px",
          height: "52px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          fontSize: "22px",
          zIndex: 9999,
        }}
      >
        💬
      </div>

      {/* Popup */}
      {open && <ChatPopup role={role} onClose={() => setOpen(false)} />}
    </>
  );
}
